import React from 'react'
import Navbar from '../components/Navbar'
import HiringSites from '../components/HiringSites'
import Footer from '../components/Footer'
function HiringPage() {
  return (
    <div>
      <Navbar/>
      <HiringSites/>
      <Footer/>
      
    </div>
  )
}

export default HiringPage